import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { HealthComponent } from './components/health/health.component';

const routes: Routes = [
  { path: '', redirectTo: 'sso', pathMatch: 'full' },
  { path: 'sso', component: LoginComponent },
  { path: 'health', component: HealthComponent },
  { path: '**', redirectTo: 'sso' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
